import { courseConstants } from './constants';


var viewActions = require ('../../store/view.actions');

var courseService = require ('./api');

export const courseActions = {
    getSchoolCourse, toggleStudentToMultipleActionList, 
    getCourseQualifications, getCourseTeachers, enroleStudent,unEnroleStudent, getSubjects,
    scheduleClasss, unScheduleClass, 
    enrollTeacher, unEnrollTeacher,
    enrollSubject, getCourseEvaluations,
    unEnroleTutor, enroleTutor,
    unEnroleSubject
};  


function unEnroleSubject( token, courseID, courseSubjectID)   { 

  return dispatch => {
          courseService.unEnroleSubject( token, courseID, courseSubjectID)
          .then( json => {
              dispatch( getSubjects( token, courseID ) ) ;
          } )
          
  }
}

function enrollSubject( token, courseID, courseSubjectID)   { 
  return dispatch => {
          courseService.enrollSubject( token, courseID, courseSubjectID)
          .then( json => {
              dispatch( getSubjects( token, courseID ) ) ;
          } )
          
  }
}

function enrollTeacher( token, courseID, courseSubjectID, data)  { 
  return dispatch => {
          courseService.enrollTeacher( token, courseID, courseSubjectID, data) 
          .then( json => {
            // FIXME: HAGO EL RELOAD DEL CURSO PARA HACER MAS RAPIDO
              dispatch( getSubjects( token, courseID ) ) ;
              
              // dispatch({
              //   type: courseConstants.TEACHER_ENROLED,
              //   newStudent: json
              // })
          } )
          
  }
}

function unEnrollTeacher( token, courseID, courseSubjectID, persona_id)  { 
  return dispatch => {
          courseService.unEnrollTeacher( token, courseID, courseSubjectID, persona_id) 
          .then( json => {
            // FIXME: HAGO EL RELOAD DEL CURSO PARA HACER MAS RAPIDO
              dispatch( getSubjects( token, courseID ) ) ;
              
              // dispatch({
              //   type: courseConstants.TEACHER_ENROLED,
              //   newStudent: json
              // })
          } )
          
  }
}
function scheduleClasss( token, courseID, courseSubjectID, data)  { 
  return dispatch => {
          courseService.scheduleClasss( token, courseID, courseSubjectID, data) 
          .then( json => {
              // FIXME: HAGO EL RELOAD DEL CURSO PARA HACER MAS RAPIDO
              dispatch( getSubjects( token, courseID ) ) ;
              // dispatch({
              //   type: courseConstants.STUDENT_ENROLED,
              //   newStudent: json
              // })
          } )
          
  }
}
 
function unScheduleClass( token, courseID, courseSubjectID, courseSubjectScheduleID ) { 
  return dispatch => {
        courseService.unScheduleClass( token, courseID, courseSubjectID, courseSubjectScheduleID )
          .then( json => {

              // FIXME: HAGO EL RELOAD DEL CURSO PARA HACER MAS RAPIDO
              dispatch( getSubjects( token, courseID ) ) ;

              // dispatch({
              //   type: courseConstants.UNSCHEDULE_CLASS,
              //   unScheduledClass: json
              // })
          } )
          
  }
}

function unEnroleStudent(token, courseID, personaID) { 
  return dispatch => {
          courseService.unEnroleStudent( token, courseID, personaID )
          .then( json => {
              dispatch({
                type: courseConstants.STUDENT_UNENROLED,
                unEnroledStudent: json
              })
          } )
          
  }
}


function enroleStudent(token, courseID, calendarID, personaID) { 
  return dispatch => {
          // dispatch(viewActions.isLoadingModule('getCourseTeachers',true)) ;
       
          courseService.enroleStudent( token, courseID, calendarID, personaID )
          .then( json => {
              dispatch({
                type: courseConstants.STUDENT_ENROLED,
                newStudent: json
              })
              // dispatch(viewActions.isLoadingModule('getCourseTeachers',false)) ;
          } )
          
  }
}



function unEnroleTutor(token, courseID, personaID) { 
  return dispatch => {
          courseService.unEnroleTutor( token, courseID, personaID )
          .then( json => {
              dispatch({
                type: courseConstants.TUTOR_UNENROLED,
                unEnroledTutor: json
              })
          } )
          
  }
}

function enroleTutor(token, courseID, calendarID, personaID) { 
  return dispatch => {
          // dispatch(viewActions.isLoadingModule('getCourseTeachers',true)) ;
       
          courseService.enroleTutor( token, courseID, calendarID, personaID )
          .then( json => {
              dispatch({
                type: courseConstants.TUTOR_ENROLED,
                newTutor: json
              })
              // dispatch(viewActions.isLoadingModule('getCourseTeachers',false)) ;
          } )
          
  }
}

function getCourseTeachers( token, courseID ) { 
  return dispatch => {
          // dispatch(viewActions.isLoadingModule('getCourseTeachers',true)) ;
       
          courseService.getCourseTeachers( token, courseID )
          .then( json => {
              dispatch({
                type: courseConstants.SHOW_COURSE_TEACHERS,
                courseTeachers: json
              })
              // dispatch(viewActions.isLoadingModule('getCourseTeachers',false)) ;
          } )
          
  }
}

function getSubjects( token, courseID ) { 
  return dispatch => {
          dispatch(viewActions.isLoadingModule('getSubjects',true)) ;
          courseService.getSubjects( token, courseID )
          .then( json => {
              dispatch({
                type: courseConstants.SHOW_COURSE_SUBJECTS,
                courseSubjects: json
              })
              dispatch(viewActions.isLoadingModule('getSubjects',false)) ;
          } )
          
  }
}

function getCourseEvaluations( token, courseID ) { 
  return dispatch => {
          dispatch(viewActions.isLoadingModule('getCourseEvaluations',true)) ;
          courseService.getCourseEvaluations( token, courseID )
          .then( json => {
              dispatch(
                {
                  type: courseConstants.SHOW_COURSE_EVALUATIONS,
                  courseEvaluations: json
                }
              )
              dispatch(viewActions.isLoadingModule('getCourseEvaluations',false))
          } )
          
  }
}

function getCourseQualifications( token, courseID ) { 
  return dispatch => {
          dispatch(viewActions.isLoadingModule('getCourseQualifications',true)) ;
          courseService.getCourseQualifications( token, courseID )
          .then( json => {
              dispatch(showCourseQualifications( json))
              dispatch(viewActions.isLoadingModule('getCourseQualifications',false))
          } )
          
  }
}

function getSchoolCourse( token, courseID, calendarID ) { 
    return dispatch => {
            dispatch(viewActions.isLoadingModule('getSchoolCourse',true));
            courseService.getSchoolCourse( token, courseID, calendarID )
            .then( json => {
                dispatch(showSchoolCourse( json))
                dispatch(viewActions.setMainTitle('Curso ' + json.name + " - Turno: " + json.shift_name ))
                dispatch(viewActions.isLoadingModule('getSchoolCourse',false))
            } )
            
    }
  }

function toggleStudentToMultipleActionList (student, index) {
  return {
    type: courseConstants.TOGGLE_STUDENT_MULTIPLE_ACTION_LIST,
    index: index,
    student: student
  }
}


function showCourseQualifications(json) {
  return {
    type: courseConstants.SHOW_QUALIFICATIONS,
    qualificationsGrid: json
  }
}

function showSchoolCourse(json) {
    return {
      type: courseConstants.SHOW_COURSES,
      course: json
    }
  }

 